export enum KeyboardKeys {
    ArrowLeft = 'ArrowLeft',
    ArrowRight = 'ArrowRight',
    Enter = 'Enter',
    Escape = 'Escape',
    Space = 'Space',
    EmptySpace = ' ',
    Tab = 'Tab'
}
